import React from 'react';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';
import styles from './PageLayout.module.scss';

export interface IPageLayoutProps extends React.HTMLProps<HTMLDivElement> {
  title: string
  className?: string
}

const PageLayout:React.FC<IPageLayoutProps> = ({
  className, title, children, ...props
}) => (
  <div className={classNames(styles.pageLayout, className)} {...props}>
    <Helmet>
      <title>{`${title} | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
    </Helmet>
    {children}
  </div>
);

export default PageLayout;
